import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  ChoiceList,
  FormLayout,
  Layout,
  Filters,
  Select,
  Toast,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import { accessNavigation } from "../../Helpers";
import { ExportIcon } from "@shopify/polaris-icons";
import moment from "moment";

const OtpActivities = () => {
  const navigate = useNavigate();
  const ref = useRef();
  const format = "YYYY-MM-DD HH:mm:ss";
  const modalId = useRef("");
  const perPage = 200;
  const [ts, setTs] = useState("");
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const handleAddMenu = () => {
    navigate(`/admin/navigation/add-menu`);
  };
  const handleEditMenu = (e) => {
    navigate(`/admin/navigation/${e.currentTarget.id}`);
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "Event", value: "event" },
            { label: "Phone", value: "phone" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: true,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState("");
  const handleSelectChangeChannel = (value) => {
    setSelectedChannel(value);
  };
  useEffect(() => {
    fetchData();
  }, [page, availability, queryValue, ts, selectedChannel]);
  async function fetchData() {
    let responseItems = "";

    try {
      responseItems = await axios.get(
        `/activity-logs${
          queryValue
            ? `?filter[${
                availability === "" ? "event" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      !responseItems.data.data.data.length
        ? setIsListEmpty(true)
        : setIsListEmpty(false);
      // setTotalPages(result.data.data.total);
      setItems(
        responseItems.data.data.data.map((item, index) => [
          <div className="row_click2">{item?.id}</div>,
          <div className="row_click2">{item?.event ?? "-"}</div>,
          <div className="row_click2">
            {moment(item?.event_time).format("YYYY-MM-DD HH:mm:ss")}
          </div>,
          <div className="row_click2">{item?.phone ?? "-"}</div>,
          <div className="row_click2">{item?.correlation_id ?? "-"}</div>,
          <div className="row_click2">{item?.error_code ?? "-"}</div>,
        ])
      );
    } catch (error) {
      console.log(error);
    }

    setIsLoading(false);
  }
  const [activeToast, setActiveToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(
    "JSON exported successfully"
  );
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const toastMarkup = activeToast ? (
    <Toast content={toastMessage} onDismiss={toggleActiveToast} />
  ) : null;
  const [isExporting, setIsExporting] = useState(false);
  const handleExport = () => {
    setIsExporting(true);
    const bodyObj = { entity_type: "navigation_data" };
    axios
      .post(`/s3/save-file`, bodyObj)
      .then((result) => {
        setIsExporting(false);
        toggleActiveToast();
      })
      .catch(function (error) {});
  };

  return (
    accessNavigation() && (
      <Page
        title="OTP Activities"

        // secondaryActions={[
        //   {
        //     content: "Export",
        //     onAction: handleExport,
        //     loading: isExporting,
        //     icon: ExportIcon,
        //   },
        // ]}
      >
        <Card>
          {loadingMarkup}
          <Card.Section>
            <FormLayout>
              <Filters
                queryValue={queryValue}
                filters={filters}
                appliedFilters={appliedFilters}
                onQueryChange={handleFiltersQueryChange}
                onQueryClear={handleQueryValueRemove}
                onClearAll={handleFiltersClearAll}
              />
            </FormLayout>
          </Card.Section>
          <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              <Text variant="bodyMd" as="p" fontWeight="medium">
                ID
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Event
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Event Time
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Phone
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Correlation ID
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Status
              </Text>,
            ]}
            rows={items}
            verticalAlign="middle"
            increasedTableDensity
          />
          {emtyState}
          {totalPages >= 2 && (
            <div
              style={{
                paddingTop: "10px",
                textAlign: "center",
                paddingBottom: "10px",
              }}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
                size="large"
              />
            </div>
          )}
        </Card>{" "}
        {toastMarkup}
      </Page>
    )
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default OtpActivities;
